import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { TranslateModule } from '@ngx-translate/core'
import { GbPresenterToolsTextComponent } from '../gb-presenter-tools-text/gb-presenter-tools-text.component'

@Component({
  selector: 'gb-presenter-tools-smart-text',
  imports: [ReactiveFormsModule, MatFormFieldModule, MatInputModule, TranslateModule, GbPresenterToolsTextComponent],
  templateUrl: './gb-presenter-tools-smart-text.component.html',
  styleUrl: './gb-presenter-tools-smart-text.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbPresenterToolsSmartTextComponent {
  @Input() toolsFormGroup!: FormGroup
  @Input() uuid!: string | null | undefined

  hideFields = ['font_style']

  get textControl(): FormControl {
    return this.toolsFormGroup.get('text') as FormControl
  }
}
